import * as THREE from 'three'
import { RoundedBox } from '@react-three/drei'
import { Helper } from '../../../../../classes/helper'
import { useMeasures } from '../../../../../hooks/state/useMeasures'
import { useRoof } from '../../../../../hooks/state/useRoof'
import { CachedMeshPhysicalMaterial } from '../../../../material/cachedMeshPhysicalMaterial'
import React from 'react'
import { LedSpot } from '../../../../utility/light/LedSpot'
import { useVerandaSelector } from '../../../../..'

export const QubusBar = (): JSX.Element | null => {
  const {
    depth,
    userWidth,
    verandaTyp,
    angleCompensation,
    offsetRoofLog,
    frontHeight,
    hasLedStripe,
    attachedSize,
  } = useMeasures()
  const { color, amplitude } = useRoof()
  const nightMode = useVerandaSelector((state) => state.scene.nightMode)

  const barHeight = verandaTyp.bar.width ? verandaTyp.bar.width : attachedSize.y

  const glowYellow = new THREE.MeshBasicMaterial({
    color: new THREE.Color(7, 4, 0.5),
    toneMapped: false,
  })

  return (
    <group
      position={[0, 0, 0]}
      rotation={[0, Helper.convertAngleToRadiant(0), 0]}
    >
      {[...Array(2)].map((_, index) => (
        <mesh
          key={`barQubus${index}`}
          position={[
            0,
            frontHeight + barHeight / 2,
            depth! * index -
              (index ? verandaTyp.log.depth / 2 : -verandaTyp.log.depth / 2),
          ]}
          castShadow={true}
          rotation={[0, 0, Helper.convertAngleToRadiant(90)]}
        >
          <RoundedBox
            args={[
              barHeight,
              userWidth - verandaTyp.log.width,
              verandaTyp.log.depth,
            ]}
            radius={0.0005}
            smoothness={0.5}
            castShadow={true}
            matrixWorldAutoUpdate={undefined}
            getObjectsByProperty={undefined}
            getVertexPosition={undefined}
          >
            <CachedMeshPhysicalMaterial color={color} />
          </RoundedBox>
          {hasLedStripe && (
            <>
              {nightMode && (
                <rectAreaLight
                  width={0.05}
                  height={userWidth}
                  color={glowYellow.color}
                  intensity={5}
                  position={[-barHeight / 2, 0, 0]}
                  rotation={[0, Math.PI / 2, 0]}
                />
              )}
              <LedSpot
                geometry={new THREE.BoxGeometry(0.005, userWidth, 0.01)}
                material={glowYellow}
                position={[-barHeight / 2, 0, 0]}
                visible={nightMode}
              />
            </>
          )}
        </mesh>
      ))}

      {[...Array(2)].map((_, index) => (
        <mesh
          key={`logQubuse${index}`}
          position={[
            (userWidth / 2) * (index ? -1 : 1),
            frontHeight + barHeight / 2,
            depth! / 2,
          ]}
          castShadow={true}
          rotation={[
            Helper.convertAngleToRadiant(90),
            Helper.convertAngleToRadiant(90),
            0,
          ]}
        >
          <RoundedBox
            args={[barHeight, depth, verandaTyp.log.width]}
            radius={0.0005}
            smoothness={0.5}
            castShadow={true}
            matrixWorldAutoUpdate={undefined}
            getObjectsByProperty={undefined}
            getVertexPosition={undefined}
          >
            <CachedMeshPhysicalMaterial color={color} />
          </RoundedBox>
          {hasLedStripe && (
            <LedSpot
              geometry={
                new THREE.BoxGeometry(0.005, depth - verandaTyp.log.depth, 0.01)
              }
              material={glowYellow}
              position={[-barHeight / 2, 0, 0]}
              visible={hasLedStripe}
            />
          )}
        </mesh>
      ))}
    </group>
  )
}
